
 const paymentMethodTypesEfileTypeDocumentReducer = (state = [], action) => {
  switch (action.type) {
    case 'LANDSHARK_PAYMENT_METHOD_TYPES_EFILE_TYPE_DOCUMENT':
      return action.results;
    default:
      break;
  }
  return state;
}

export default paymentMethodTypesEfileTypeDocumentReducer;